
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { Lavorazione, StatoLavorazione, VariazioneLavorazione, Azione, ProgressoSpedizione as ProgressoDTO } from '@/models';
import { store, StoreActions } from '@/store';
import dayjs from 'dayjs';

@Component
export default class ProgressoSpedizione extends Vue {

    get lavorazione(): Lavorazione | undefined {
        return store.state.lavorazioneCorrente;
    }

    get headers(): any[] {
        let titoli = [
            { 
                text: 'Data Spedizione',
                value: 'dataSpedizione',
                align: 'center',
                sortable: false
            }
        ];

        if(this.lavorazione != undefined) {
            let tipoTaglia: any = this.lavorazione.tipoTagliaDecodificato;
            for (let index = 1; index <= 16; index++) {
                const nomeProp = `taglia${index.toString().padStart(2, '0')}`;
                const valProp: string = tipoTaglia[nomeProp];
                
                let end = valProp == undefined || valProp == '';
                if(!end) {
                    titoli.push({ 
                        text: valProp,
                        value: valProp,
                        align: 'center',
                        sortable: false
                    });
                }
            }

            titoli.push({ 
                text: 'DDT',
                value: 'DDT',
                align: 'center',
                sortable: false
            });
        }

        return titoli;
    }

    get items(): any[] {
        let rows: any[] = [];

        if(this.lavorazione != undefined) {
            let capiTaglia: any = this.lavorazione.innerLavorazione;

            this.lavorazione.progressiSpedizione.forEach(prog => {
                let rigaProg = this.prog2RigaProg(prog);
                rows.push(rigaProg);
            });
        }

        return rows;
    }

    prog2RigaProg(progresso: ProgressoDTO): any {
        let riga = { 
            id: progresso.indice, 
            values: [] as string[], 
            ddt: progresso.idSpedizione, 
            dataElaborazione:progresso.dataElaborazione,
            ddtResoData:progresso.ddtResoData,
        };

        for (let index = 1; index < this.headers.length; index++) {
            const nomeProp = `qtaTaglia${index.toString().padStart(2, '0')}`;
            const valProp: string = (progresso as any)[nomeProp].toString(); 
            
            riga.values.push(valProp);
        }

        return riga;
    }
}

